import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { CleaveOptions } from 'cleave.js/options';

import DropdownModel from '@/common/interfaces/DropdownModel';

import TextRow from '@/forms/FormElements/Rows/TextRow/TextRow.vue';
import DropdownRow from '@/forms/FormElements/Rows/DropdownRow/DropdownRow.vue';

import RowValidationMixin from '@/forms/FormElements/Mixins/RowValidationMixin';

import { names } from './AddressRow.validation';
import { AddressFieldType } from '@/common/interfaces/dto/Address';

import {
  clearChangingFields,
  getStates,
  getCountries,
  isShow,
  isCanada,
  isStateCountries,
} from './AddressRow.helper';

@Component({ components: { TextRow, DropdownRow } })
export default class AddressRow extends mixins(RowValidationMixin) {
  // Shorten list of countries by IsBrochure criteria
  @Prop({ type: Boolean, default: false })
  readonly IsBrochure!: boolean;
  @Prop({ type: Number, default: 50 })
  readonly addressLine1MaxLength: number;
  @Prop({ type: Number, default: 50 })
  readonly addressLine2MaxLength: number;
  @Prop({ type: Number, default: 50 })
  readonly cityMaxLength: number;
  @Prop({ type: Number, default: 10 })
  readonly postCodeMaxLength: number;
  @Prop({ type: Boolean, default: false })
  readonly fullZipCode: boolean;

  names = names;

  zipFormatter: CleaveOptions = {
    blocks: [5],
    numericOnly: true,
  };

  zipFullFormatter: CleaveOptions = {
    blocks: [9],
    numericOnly: true,
  };

  countryChanged(value, prevValue) {
    if (isStateCountries(value) || isStateCountries(prevValue))
      clearChangingFields(this.input as any);
  }

  fullOption(option) {
    this.$emit('fullOption', option)
  }

  get getStateLabel() {
    return isCanada(this.countryId) ? 'Province' : 'State';
  }

  get countryId() {
    return this.model[names.CountryId];
  }

  get countries() {
    return getCountries(this.IsBrochure);
  }

  get states() {
    return getStates(this.countryId);
  }

  get isStateRequred() {
    return this.validation[this.names.StateCode].requiredState !== undefined;
  }

  showPart(part: AddressFieldType) {
    const result = isShow(part, this.countryId);
    return result;
  }
}
